export enum QcqOperations { ADD, EDIT, REMOVE }

export enum ShiftFilterScope { AllShifts, FixedShifts, TemporaryShifts, Active, Inactive, Closed, Invoiced }

export enum DatePeriodEnum {
  Week = 'week',
  Month = 'month',
  Day = 'day',
  Year = 'year',
  WorkingWeek = 'workingWeek'
}

export enum ViewEnum {
  TimelineWeek = 'timelineWeek',
  Week = 'Week',
  TimelineMonth = 'timelineMonth',
  Month = 'month',
  Day = 'day',
  TimelineYear = 'timelineYear',
  Timeline4Month = 'timeline4Month',
  TimelineWorkDaysWeek = 'timelineWorkDaysWeek'
}

export enum KindOfShift { Qcq, Free, Unknown }

export enum ShiftAvailability { Temporary, Fixed }

export enum SchedulerResourceEnum { Employee, PlanningGroup }

export enum SnackbarStateEnum { Error, Success }

export enum MasterDataActionsEnum {
  Create = 'Insert',
  Read = 'Grab',
  Update = 'Update',
  Delete = 'Delete'
}

export enum MenuDataEnum {
  Simple = 'Simple',
  Industrial = 'Industrial',
  PlanningData = 'PlanningData',
  CompanyData = 'CompanyData',
  CompanyDataSettings = 'CompanyDataSettings',
  Department = 'Department',
  ProfitCenter = 'ProfitCenter',
  Employee = 'Employee',
  DepartmenSettings = 'DepartmenSettings',
  ProfitCenterSettings = 'ProfitCenterSettings',
  EmployeeSettings = 'EmployeeSettings',
  ProfitCenterSettingsWithDepartment = 'ProfitCenterSettingsWithDepartment',
  EmployeeHierarchySettings = 'EmployeeHierarchySettings',
  ProfitCenterAdditionalFieldsSettings = 'ProfitCenterAdditionalFieldsSettings',
  CommissionGroup = 'CommissionGroup',
  CommissionGroupItem = 'CommissionGroupItem',
  AddressGroup = 'AddressGroup',
  AddressGroupItem = 'AddressGroupItem',
  AddressItem = 'AddressItem',
  ProjectGroup = 'ProjectGroup',
  ProjectGroupItem = 'ProjectGroupItem',
  ProductGroup = 'ProductGroup',
  ProductGroupItem = 'ProductGroupItem',
  RecruitingGroup = 'RecruitingGroup',
  RecruitingGroupItem = 'RecruitingGroupItem',
  ToolsGroup = 'ToolsGroup',
  ToolsGroupItem = 'ToolsGroupItem',
  TicketingGroup = 'TicketingGroup',
  TicketingGroupItem = 'TicketingGroupItem',
  Configuration = 'Configuration',
  ConfigurationGroup = 'ConfigurationGroup',
  ConfigurationGroupItem = 'ConfigurationGroupItem',
  ConfigurationGroupWithFilter = 'ConfigurationGroupWithFilter',
  ConfigurationGroupItemWithFilter = 'ConfigurationGroupItemWithFilter'
}

export enum QcqQualification{ Education, Jobs, Specializations, Details }

export enum ActionsEnum {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete'
}

export enum AbsencesFilterScope { AllAbsences, ApprovedAbsencesFalse,  ApprovedAbsencesTrue, DisapprovedAbsences }
export enum MenuFilterScope { All,  Active, Passive }
export enum NoteEditMenu { Shift,  Address, Employee }

export enum SecurityArea {
  Menu = 'menu',
  PersonalDisposition = 'personaldisposition',
  Addresses = 'addresses',
  Employee = 'employee',
  Reports = 'reports',
  Absences = 'absences',
  Planning = 'planning',
  PlanningPlayground = 'planning-playground',
  PlanningBar = 'planning-bar',
  Projects = 'projects',
  Tools = 'tools'
}

export enum SecurityComponent {
  //Menu
  Dashboard = 'dashboard',
  Stammdaten = 'stammdaten',
  Address = 'address',
  MultisiteAddressSearch = 'multisite-address-search',
  Products = 'products',
  Qcq = 'qcq',
  Works = 'works',
  Shifts = 'shifts',
  Projects = 'projects',
  PrintingActivity = 'printing-activity',
  PersonalDisposition = 'personaldisposition',
  Settings = 'settings',
  Tools = 'tools',
  Cockpit = 'cockpit',
  TicketSystem = 'ticketsystem',
  //PersonalDisposition
  Allocation = 'allocation',
  Substitution = 'substitution',
  Reallocation = 'reallocation',
  //Addresses
  IconInsert = 'icon-insert',  //PlanningBar
  IconUpdate = 'icon-update',  //PlanningBar
  IconDelete = 'icon-delete',  //PlanningBar
  TransferButton = 'webreport-datatrasfer',
  //Employee
  Password = 'password',
  EmployeeIconInsert = 'icon-insert',
  EmployeeIconUpdate = 'icon-update',
  //Reports
  SendEmailIcon = 'send-email-icon',
  //Absences
  IconApprove = 'icon-approve',
  SwitchApprove = 'switch-approve',
  SwitchRefuse = 'switch-refuse',
  DragDrop = 'drag&drop',
  ReasonForAbsence = 'reason-for-absence',
  ToolbarFunctions = 'toolbar-functions',  //PlanningBar
  //Planning
  SelectBoxFiliale = 'selectbox-filiale',
  SelectBoxAbteilung = 'selectbox-abteilung',
  SelectBoxSchichtvorlage = 'selectbox-schichtvorlage',
  SelectBoxAdress = 'selectbox-adress',
  SelectBoxProject = 'selectbox-project',
  SelectBoxAbo = 'selectbox-abo',
  SelectBoxKalenderArt = 'selectbox-kalender-art',
  //PlanningPlayground
  DragDropForSchichts = 'drag-drop-for-schichts',
  EventTextOver = 'event-text-over',
  //PlanningBar
  IconAddress = 'icon-adress',
  IconProject = 'icon-project',
  IconAbo = 'icon-abo',
  IconFastPlanning = 'icon-fastplanning',
  IconKalenderArt = 'icon-kalender-art',
  IconSearch = 'icon-search',
  IconSidebar = 'icon-sidebar',
  SchedulerSettings = 'scheduler-settings',
  AdditionalProducts = 'additionalproducts',
  SetInactive = 'setinactive',
  SetActive = 'setactive',
  SetClosed = 'setclosed',
  Invoicing = 'invoicing',
  //Project
  UpdateReceiptData = 'update-receiptdata',
  //Recruiting
  Recruiting = 'recruiting',
  //Commissions
  Commission = 'commission',
  //Tools
  ReleaseIcon = 'icon-releaseFIBUrecords',
  ExportIcon = 'icon-exportFIBUrecords',
  UndoIcon = 'icon-resetFIBUrecords'
}

export enum ProductAddressEnum { Address,  Price }

export enum KeyActionEnum {
  help = 'F1',
  search = 'F2',
  edit = 'F3',
  create = 'F6',
  save = 'F8',
  delete = 'F7',
  cancel = 'Escape',
  selectAll = 'ctrl+a',
}